<template>
  <div class="planProductInquiry">
    <el-dialog :visible.sync="dialogVisible" width="70%" :modal="false" custom-class="big">
      <!-- <el-radio v-model="pointValue"  :label="1">整体预算优先</el-radio>
      <el-radio v-model="pointValue"  :label="2">按照我的标准来</el-radio> -->
      <product-inquiry-type-tab ref="inquiryTypeTab" :sendButtom="'按着这个行程请尽快给'" @tabCheckType="tabCheckType"
        style="background:white;width: 12rem;" :sendButtom2="'我提供产品'" :nowShowType="nowShowType" @sumitBox="sumitBox"></product-inquiry-type-tab>
      <div class="dialogMain">
        <div class="dialogFa">
          <p class="dialogLeftP1">第一步：选择日期</p>
          <div class="dialogLeft">
            <div class="dialogRightChoose">
              <div v-for="(item, index) in planDays" :key="index" @click="handleCheckedCitiesChange(item)" 
                :style="item.planDay==planDay.planDay?'box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 7px 2px;':''"
                style="border: 1px solid #EAEAEA;padding: 0.1rem;">
                <div>
                  <span>{{ dateFormatYMD(item.planDate,"-")}}&nbsp;&nbsp;</span>
                  <span class="span2">D{{ item.planDay }}&nbsp;</span>
                  <span v-if="item.cityList.length>0" class="span3">
                    <span v-for="(city,cityIndex) in item.cityList" :key="cityIndex">
                      {{city.cityName}} 
                    </span>
                  </span>
                  <span v-else style="font-size: 0.18rem;color: #48AD19;">请完善行程，否则行程无法发送成功</span>
                </div>
                <div class="dialogRightChooseMain" v-if="nowShowType == 'hotel'" :key="item.planDay">
                  <template v-if="item.inquiryObj&&JSON.stringify(item.inquiryObj.hotel) !== '{}' && item.inquiryObj.hotel">
                    <hotel-product-inquiry-show :hotelData="item.inquiryObj.hotel"></hotel-product-inquiry-show>
                    <i class="el-icon-remove-outline" @click.stop="clearData(item)"></i>
                  </template>
                </div>
                <div class="dialogRightChooseMain" v-else-if="nowShowType == 'site'" :key="item.planDay">
                  <template v-if="item.inquiryObj&&JSON.stringify(item.inquiryObj.site) !== '{}' && item.inquiryObj.site">
                    <div>
                      <site-product-inquiry-show :item="item.inquiryObj.site"></site-product-inquiry-show>
                    </div>
                    <i class="el-icon-remove-outline" @click.stop="clearData(item)"></i>
                  </template>
                </div>
                <div class="dialogRightChooseMain" v-else :key="item.planDay">
                  <template v-if="item.inquiryObj&&JSON.stringify(item.inquiryObj[nowShowType]) !== '{}' && item.inquiryObj[nowShowType]">
                    <div>
                      <span v-if="item.inquiryObj[nowShowType].adult > 0 || item.inquiryObj[nowShowType].children > 0">
                        {{ item.inquiryObj[nowShowType].adult }}成人{{item.inquiryObj[nowShowType].children}}儿童
                      </span>
                      <div style="margin-top:0.05rem">
                        <p v-if="nowShowType=='visa'" style="margin-top:0.05rem">
                          <span v-for="(item1,index1) in item.inquiryObj[nowShowType].countrys" :key="index1">
                            {{item1.countryName}} 
                          </span>
                        </p>
                        <p style="margin-top:0.05rem" v-for="(item1,index1) in item.inquiryObj[nowShowType][nowShowTypeObj.propName]" :key="index1">
                          <span>{{item1.addType}}</span>
                          <span v-if="nowShowType=='spot'&&item1.cityName && item1.cityName!=''">
                            目的地 {{ item1.cityName}} {{item1.spotName}} 的{{item1.spotType}}
                          </span>
                          <span v-if="nowShowType=='traffic'&&item1.trafficType && item1.trafficType!=''">
                            车型 {{ item1.trafficType}} {{item1.busType}} {{item1.busNumber}}辆
                          </span>
                          <span v-if="nowShowType=='guide'&&item1.busNumber && item1.busNumber!=''">
                            {{item1.busNumber}}位 {{ item1.trafficType}}
                          </span>
                          <span v-if="nowShowType=='communication'&&item1.cityName && item1.cityName!=''">
                            出发地 {{ item1.cityName}} 目的地 {{item1.endCityName}} {{item1.trafficType}} {{item1.expectFlight}}
                          </span>
                          <span v-if="nowShowType=='restaurant'&&item1.cityName && item1.cityName!=''">
                            {{ item1.cityName}} {{item1.number}} {{item1.mealType}} 预算{{item1.budgetPrice}}{{item1.currency}}
                          </span>
                          <span v-if="item1.visaType && item1.visaType!=''">
                            {{ item1.visaType}} {{item1.visaContent}}
                            <p v-if="item.inquiryObj[nowShowType].countrys.length==0" style="color:var(--bottomBtnColor);">!!!没有选择签证国家,询价将发送不成功</p>
                          </span>
                          <span v-if="nowShowType=='business'&&item1.cityName && item1.cityName!=''">
                            {{ item1.cityName}} {{item1.businessType}} {{item1.businessIndustry}} {{item1.time}} {{item1.objective}}
                          </span>
                          <span v-if="(nowShowType=='charact'||nowShowType=='service')">
                            <span v-if="item1.cityName && item1.cityName!=''">{{ item1.cityName}} {{item1.content}}</span>
                            <p v-if="(!item1.cityName||item1.cityName=='')&&item.inquiryObj[nowShowType].remarks && item.inquiryObj[nowShowType].remarks!=''" style="color:var(--bottomBtnColor);">!!!没有选择城市,询价将发送不成功</p>
                          </span>
                        </p>
                        <p style="margin-top:0.05rem" v-if="item.inquiryObj[nowShowType].remarks && item.inquiryObj[nowShowType].remarks!=''">备注：{{item.inquiryObj[nowShowType].remarks}}</p>
                      </div>
                    </div>
                    <i class="el-icon-remove-outline" @click.stop="clearData(item)"></i>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dialogRightTitle">
          <p class="dialogLeftP1">
            第二步：录入标准
            <span>求助客服<img src="@/assets/png/wx.png" /></span><span class="Dline"></span>
          </p>
          <div class="dialogRight" v-if="planDay.inquiryObj">
            <hotel-product-inquiry v-if="nowShowType == 'hotel'" :hotelData="planDay.inquiryObj.hotel"></hotel-product-inquiry>
            <div v-else-if="nowShowType == 'site'">
              <div style="margin-bottom: 0.05rem;display: flex;align-items: center;">
                <span style="margin-right:0.1rem">{{planDay.inquiryObj.site.useDate}}</span>
                <el-select v-model="planDay.inquiryObj.site.cityName" placeholder="请选择" size="mini" style="width:1.1rem" 
                  @change="changeCity($event,planDay.inquiryObj.site)">
                  <el-option v-for="item in planDay.cityList" :key="item.id" :label="item.cityName" :value="item"></el-option>
                </el-select>
                <span style="margin-left:0.1rem">活动时段：</span>
                <el-select v-model="planDay.inquiryObj.site.useDay" placeholder="请选择天数" style='width:1.9rem' size="mini">
                  <el-option v-for="text in durationOption" :key="text" :label="text" :value="text"></el-option>
                </el-select>
              </div>
              <site-product-inquiry :siteData="planDay.inquiryObj.site"></site-product-inquiry>
            </div>
            <div v-else class="dialogRightContent">
              <people-box :showRenNumber="false" :spotData="planDay.inquiryObj[nowShowType]"></people-box>
              <div class="dialogRightContentButton">
                <div> <b>亲，您需要的{{nowShowTypeObj.desc}}是：</b> </div>
                <div v-if="nowShowType=='visa'">
                  <p style="margin-top: 0.1rem;">
                    <el-checkbox-group v-model="planDay.inquiryObj[nowShowType].countrys">
                      <el-checkbox v-for="(item,index) in planDay.countryList" :key="index" :label="item">{{item.countryName}}</el-checkbox>
                    </el-checkbox-group>
                  </p>
                  <div style="margin-top: 0.1rem;"> <b>您申请的是</b> </div>
                </div>
                <div v-for="(item,index) in planDay.inquiryObj[nowShowType][nowShowTypeObj.propName]" :key="index" class="content">
                  <template v-if="nowShowType=='spot'">
                    <p>
                      <span style="width: 0.15rem;">{{item.addType}}</span>
                      <label>{{item.useDate}}</label>
                      <el-select v-model="item.cityName" placeholder="请选择" size="mini" style="width:1.1rem" @change="changeCity($event,item)">
                        <el-option v-for="item in planDay.cityList" :key="item.id" :label="item.cityName" :value="item"></el-option>
                      </el-select>
                      <spot-autocomplete :spotItem="item"></spot-autocomplete>
                      <label>的</label>
                    </p>
                    <p>
                      <el-radio-group v-model="item.spotType" style="margin-left: 1.12rem;">
                        <el-radio label="散客票">散客票</el-radio>
                        <el-radio label="团队票">团队票</el-radio>
                        <el-radio label="专业讲解">专业讲解</el-radio>
                      </el-radio-group>
                      <operation-button class="operationButton" :arr="planDay.inquiryObj[nowShowType].spotProductInquiryList" :index="index" :addObj="spotProductInquiryList"
                        :addAction="true" @addSpotType="addSpotType"></operation-button>
                    </p>
                  </template>
                  <template v-else-if="nowShowType=='traffic'">
                    <p>
                      <span style="width: 0.15rem;">{{item.addType}}</span>&nbsp;
                      <traffic-product-inquiry class="trafficProductInquiry" :carItem="item"></traffic-product-inquiry>
                      <operation-button class="operationButton" :arr="planDay.inquiryObj[nowShowType].trafficProductInquiries" :index="index" 
                        :addObj="trafficProductInquiries"></operation-button>
                    </p>
                  </template>
                  <template v-else-if="nowShowType=='communication'">
                    <p>
                      <span style="width: 0.15rem;">{{item.addType}}</span>
                      <label>{{item.useDate}}</label>
                      <el-select v-model="item.cityName" placeholder="请选择" size="mini" style="width:1.1rem" @change="changeCity($event,item)">
                        <el-option v-for="item in planDay.cityList" :key="item.id" :label="item.cityName" :value="item"></el-option>
                      </el-select>
                      <span>&nbsp;&nbsp;至</span>
                      <el-select v-model="item.endCityName" placeholder="请选择" size="mini" style="width:1.1rem" @change="changeCity($event,item,1)">
                        <el-option v-for="item in planDay.cityList" :key="item.id" :label="item.cityName" :value="item"></el-option>
                      </el-select>
                      <label>的什么交通服务</label>
                      <el-select v-model="item.trafficType" placeholder="请选择" style='width:0.69rem' size="mini">
                        <el-option v-for="(text,i) in communicationOptionOne" :key="i" :label="text" :value="text"></el-option>
                      </el-select>
                    </p>
                    <p>
                      <el-input v-model="item.expectFlight" placeholder="期望的班(船)/次或时间" size="mini" style="width: 2.93rem;margin: 0 0.1rem 0 0.25rem;"></el-input>
                      <operation-button class="operationButton" :arr="planDay.inquiryObj[nowShowType].bigTrafficProductInquiries" :index="index" :addObj="bigTrafficProductInquiries"
                        :addAction="true" @addSpotType="addSpotType"></operation-button>
                    </p>
                  </template>
                  <template v-else-if="nowShowType=='restaurant'">
                    <p>
                      <span style="width: 0.15rem;">{{item.addType}}</span>
                      <label>{{item.useDate}}</label>
                      <el-select v-model="item.cityName" placeholder="请选择" size="mini" style="width:1.1rem" @change="changeCity($event,item)">
                        <el-option v-for="item in planDay.cityList" :key="item.id" :label="item.cityName" :value="item"></el-option>
                      </el-select>
                      <el-input v-model="item.number" placeholder="请填写" style="width:0.77rem" size="mini"
                        @input="item.number=item.number.replace(/[^\d]/g,'')"></el-input>
                      <label>顿</label>
                      <el-select v-model="item.mealType" placeholder="请选择" style='width:1rem' size="mini">
                        <el-option v-for="(text,i) in restaurantOptionOne" :key="i" :label="text" :value="text"></el-option>
                      </el-select>
                    </p>
                    <p>
                      <el-input v-model="item.budgetPrice" placeholder="预算（如有）" style="width: 1.62rem;margin: 0 0.1rem 0 0.25rem;" size="mini"></el-input>
                      <currency-autocomplete :obj="item" :sizeType="'mini'" :styleStr="'width:1rem'"></currency-autocomplete>&nbsp;
                      <operation-button class="operationButton" :arr="planDay.inquiryObj[nowShowType].mealProductInquiries" :index="index" :addObj="mealProductInquiries"
                        :addAction="true" @addSpotType="addSpotType"></operation-button>
                    </p>
                  </template>
                  <template v-else-if="nowShowType=='guide'">
                    <p>
                      <span style="width: 0.15rem;">{{item.addType}}</span>
                      <el-input v-model="item.busNumber" placeholder="" style="width:0.5rem" size="mini"
                        @input="item.busNumber=item.busNumber.replace(/[^\d]/g,'')"></el-input>
                      <label>位</label>
                      <el-select v-model="item.trafficType" placeholder="请选择" style='width:1.5rem' size="mini">
                        <el-option v-for="(text,i) in guideOptionOne" :key="i" :label="text" :value="text"></el-option>
                      </el-select>&nbsp;
                      <operation-button class="operationButton" :arr="planDay.inquiryObj[nowShowType].trafficProductInquiries" :index="index" :addObj="trafficProductInquiries"
                      ></operation-button>
                    </p>
                  </template>
                  <template v-else-if="nowShowType=='visa'">
                    <p>
                      <span style="width: 0.15rem;">{{item.addType}}</span>
                      <el-select v-model="item.visaType"  placeholder="请选择" style='width:120px' size="mini">
                        <el-option v-for="(text,i) in visaOptionOne" :key="i" :label="text" :value="text"></el-option>
                      </el-select>
                      <el-select v-model="item.visaContent" placeholder="请选择" style='width:120px' size="mini">
                        <el-option v-for="(text,i) in visaOptionTwo" :key="i" :label="text" :value="text"></el-option>
                      </el-select>&nbsp;
                      <operation-button class="operationButton" :arr="planDay.inquiryObj[nowShowType].visaProductInquiries" :index="index" :addObj="visaProductInquiries"
                      ></operation-button>
                    </p>
                  </template>
                  <template v-if="nowShowType=='business'">
                    <p class="businessType">
                      <span style="width: 0.15rem;">{{item.addType}}</span>
                      <label>{{item.useDate}}</label>
                      <el-select v-model="item.cityName" placeholder="请选择" size="mini" style="width:1rem" @change="changeCity($event,item)">
                        <el-option v-for="item in planDay.cityList" :key="item.id" :label="item.cityName" :value="item"></el-option>
                      </el-select>&nbsp;
                      <el-radio v-model="item.businessType" label="商务拜访">商务拜访</el-radio>&nbsp;
                      <el-radio v-model="item.businessType" label="邀请函及商务联系">邀请函及商务联系</el-radio>
                      <el-input v-model="item.businessIndustry"
                        :placeholder="item.businessType=='商务拜访'?'您想拜访的行业':'您的对口行业'"
                        size="mini" style="width: 1rem;"></el-input>
                    </p>
                    <p>
                      <el-input v-model="item.time" :placeholder="item.businessType=='商务拜访'?'拜访时间和拜访时长':'邀请时间和邀请时长'"
                        size="mini" style="width: 2.3rem;margin-left: 0.25rem;"></el-input>
                      <el-input v-model="item.objective" placeholder="要求及拜访目的"
                        size="mini" style="width:2.1rem;margin-right: 0.05rem;"></el-input>
                      <operation-button class="operationButton" :arr="planDay.inquiryObj[nowShowType].businessProductInquiries" :index="index" :addObj="businessProductInquiries"
                        :addAction="true" @addSpotType="addSpotType"></operation-button>
                    </p>
                  </template>
                  <template v-if="nowShowType=='charact'">
                    <p class="businessType">
                      <span style="width: 0.15rem;">{{item.addType}}</span>
                      <label>{{item.useDate}}</label>
                      <el-select v-model="item.cityName" placeholder="请选择" size="mini" style="width:1rem" @change="changeCity($event,item)">
                        <el-option v-for="item in planDay.cityList" :key="item.id" :label="item.cityName" :value="item"></el-option>
                      </el-select>&nbsp;
                      <b style="margin-right: 0.05rem;">安排什么特色体验</b>
                      <el-select v-model="item.content" placeholder="请选择" style='width:1.2rem' size="mini" allow-create filterable>
                        <el-option v-for="(text,index1) in charactOptionOne" :key="index1" :label="text" :value="text"></el-option>
                      </el-select>&nbsp;
                      <operation-button class="operationButton" :arr="planDay.inquiryObj[nowShowType].chractProductInquiries" :index="index" :addObj="chractProductInquiries"
                        :addAction="true" @addSpotType="addSpotType"></operation-button>
                    </p>
                  </template>
                  <template v-if="nowShowType=='service'">
                    <p class="businessType">
                      <span style="width: 0.15rem;">{{item.addType}}</span>
                      <label>{{item.useDate}}</label>
                      <el-select v-model="item.cityName" placeholder="请选择" size="mini" style="width:1rem" @change="changeCity($event,item)">
                        <el-option v-for="item in planDay.cityList" :key="item.id" :label="item.cityName" :value="item"></el-option>
                      </el-select>&nbsp;
                      <b style="margin-right: 0.05rem;">安排什么服务</b>
                      <el-select v-model="item.content" placeholder="请选择" style='width:120px' size="mini">
                        <el-option v-for="(text,index1) in serviceOptionOne" :key="index1" :label="text" :value="text"></el-option>
                      </el-select>&nbsp;
                      <operation-button class="operationButton" :arr="planDay.inquiryObj[nowShowType].chractProductInquiries" :index="index" :addObj="chractProductInquiries"
                        :addAction="true" @addSpotType="addSpotType"></operation-button>
                    </p>
                  </template>
                </div>
                <p>
                  <textarea v-model="planDay.inquiryObj[nowShowType].remarks" size="mini" style="margin-top: 0.2rem; width: 5.6rem;border: none;padding: 0.05rem;"
                    :placeholder="nowShowTypeObj.placeholder?nowShowTypeObj.placeholder:'请在此处填写其他您想告知我们的需求，我们将尽快为您提供您需要的专属特价'"></textarea>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <send-inquiry-dialog @closeDialog="closeDialog" :identity="'供应商'" ref="sendInquiry"></send-inquiry-dialog>
  </div>
</template>

<script>
import productInquiryTypeTab from './child/productInquiryTypeTab.vue'
import hotelProductInquiryShow from './child/hotelProductInquiryShow.vue'
import HotelProductInquiry from './child/hotelProductInquiry.vue'
import SiteProductInquiry from './child/siteProductInquiry.vue'
import SiteProductInquiryShow from './child/siteProductInquiryShow.vue'
import trafficProductInquiry from './child/trafficProductInquiry.vue'
import operationButton from './child/operationButton.vue'
import PeopleBox from './peopleBox.vue'
import SpotAutocomplete from '../common/spotAutocomplete.vue';
import CurrencyAutocomplete from '../common/currencyAutocomplete.vue';
import SendInquiryDialog from './sendInquiryDialog.vue'
export default {
  components: { productInquiryTypeTab,hotelProductInquiryShow, HotelProductInquiry,SiteProductInquiry, SiteProductInquiryShow, PeopleBox,SpotAutocomplete
  ,operationButton,trafficProductInquiry,CurrencyAutocomplete,
    SendInquiryDialog},
  data(){
    return{
      dialogVisible:false,
      pointValue:2,
      planDays:[],
      planDay:{},
      nowShowType:'hotel',
      nowShowTypeObj:{},
      budget:{},
      durationOption: ['1晚', '0.5天', '1天', '2天', '3-4天', '5-7天', '7-14天', '14天以上'],
      spotProductInquiryList:{
        useDate:null,
        cityId:null,
        cityName:null,
        spotId:null,
        spotName:null,
        spotType:null,
        addType:null,
      },
      trafficProductInquiries:{
        useDate:null,
        cityList:[],
        trafficType:null,
        busType:null,
        busNumber:null,
        addType:null,
      },
      bigTrafficProductInquiries:{
        trafficType:null,
        useDate:null,
        cityId:null,
        cityName:null,
        endCityId:null,
        endCityName:null,
        expectFlight:null,
        addType:null,
      },
      mealProductInquiries:{
        cityId:null,
        cityName:null,
        number:null,
        mealType:null,
        meal:null,
        budgetPrice:null,
        currency:null,
        addType:null,
      },
      communicationOptionOne: ['机票', '火车', '轮船'],
      restaurantOptionOne: ['中餐', '西餐', '特色餐', '婚宴', '公司宴请'],
      guideOptionOne:['全陪兼地陪','地接导游','伴游','专业讲解'],
      visaProductInquiries:{
        countryId:null,
        countryName:null,
        visaType:null,
        visaContent:null,
        addType:null,
      },
      visaOptionOne: ['个人签证', '商务签证', '团队签证'],
      visaOptionTwo: ['旅游', '商务', '政府出行', '探亲访友', '留学', '务工'],
      businessProductInquiries:{
        cityId:null,
        cityName:null,
        businessType:null,
        businessIndustry:null,
        time:null,
        objective:null,
        addType:null,
      },
      chractProductInquiries:{
        cityId:null,
        cityName:null,
        content:null,
        addType:null,
      },
      charactOptionOne:[],
      serviceOptionOne: ['机场VIP通道', '豪车接机', '礼仪接机'],
    }
  },
  methods:{
    sumitBox(){
      var hotelDataApi=[]
      var siteDataApi=[]
      var otherDataApi=[]
      this.planDays.forEach(e=>{
        var obj = e.inquiryObj.hotel
        if(obj){
          if(obj.star!=''||obj.location!=''||obj.hotelRoomList.length>0){
            obj.startDate = this.dateFormatYMD(e.planDate,"-")
            obj.endDate = this.dateFormatYMD(this.dateAddDay(e.planDate,1).getTime(),"-")
            obj.cityId = e.cityList[e.cityList.length-1].cityId
            obj.cityName = e.cityList[e.cityList.length-1].cityName
            obj.cityNameEn = e.cityList[e.cityList.length-1].cityNameEn
            hotelDataApi.push(obj)
          }
        }
        var siteObj = e.inquiryObj.site
        if(siteObj){
          if(siteObj.cityId&&siteObj.cityName&&siteObj.dateType&&(siteObj.useDate||siteObj.useYear)){
            if(siteObj.dateType==2){
              siteObj.useDate = siteObj.useYear
            }
            if(siteObj.peopleType==2){
              siteObj.peopleNumber = siteObj.peopleNumRange
            }
            siteDataApi.push(siteObj)
          }
        }
        this.$refs.inquiryTypeTab.navTabData.forEach(item=>{
          if(item.nameEn!='hotel'&&item.nameEn!='site'&&e.inquiryObj[item.nameEn]){
            var apiList = []
            e.inquiryObj[item.nameEn][item.propName].forEach(ee=>{
              if(item.nameEn=='spot'){
                if(ee.cityId&&ee.useDate&&ee.spotId){
                  apiList.push(ee);
                }
              }else if(item.nameEn=='traffic'){
                if(ee.trafficType&&ee.busType){
                  ee.cityList=e.cityList
                  apiList.push(ee);
                }
              }else if(item.nameEn=='communication'){
                if(ee.useDate&&ee.cityId&&ee.endCityId){
                  apiList.push(ee);
                }
              }else if(item.nameEn=='guide'){
                if(ee.trafficType){
                  ee.cityList=e.cityList
                  apiList.push(ee);
                }
              }else if(item.nameEn=='visa'){
                if(e.inquiryObj[item.nameEn].countrys.length>0){
                  e.inquiryObj[item.nameEn].countrys.forEach(wlw=>{
                    if(wlw.countryId){
                      ee.countryId = wlw.countryId
                      ee.countryName = wlw.countryName
                      apiList.push(ee);
                    }
                  })
                }
              }else{
                if(ee.cityId){
                  apiList.push(ee);
                }
              }
            })   
            if(apiList.length>0){
              e.inquiryObj[item.nameEn].resourceType = item.index;
              otherDataApi.push(e.inquiryObj[item.nameEn])
            }
          }
        })
      })
      var saveObj={
        hotelProjectInquiryList:hotelDataApi,
        siteProjectInquiries:siteDataApi,
        otherTypeProjectInquiries:otherDataApi,
        planId:this.budget.planId,
      }
      this.$refs.sendInquiry.sumitBoxState = true
      this.$refs.sendInquiry.saveObj = saveObj
    },
    changeCity(value,item,type){
      if(type){
        item.endCityId = value.cityId
        item.endCityName = value.cityName
      }else{
        item.cityId = value.cityId
        item.cityName = value.cityName
      }
    },
    addSpotType (obj) {
      obj.useDate = this.dateFormatYMD(this.planDay.planDate,"-")
    },
    clearData(item){
      this.$set(item.inquiryObj,this.nowShowType, this.setHotelData(this.nowShowType,1));
    },
    beforeOpen(data){
      this.dialogVisible = true
      this.$nextTick(()=>{
        this.planDays.forEach(e=>{
          if(!e.inquiryObj){
            this.$set(e, "inquiryObj", {});
          }
        })
        if(data){
          var nameEn = this.$refs.inquiryTypeTab.navTabData.find(e=>e.index==data.state).nameEn;
          this.tabCheckType(nameEn,data)
          if(nameEn!='spot'){
            this.planDay.inquiryObj[nameEn].remarks=data.nameCn
          }
        }else{
          this.tabCheckType('hotel')
        }
      })
    },
    setHotelData(type,number,data){
      if(type=='hotel'){
        var hotelRoomList = []
        if(data&&data.roomList.length>0){
          data.roomList.forEach(e=>{
            hotelRoomList.push({
              hotelRoomName: e.productName, //房间类型
              roomNumber: e.stockNumber, //房间数
              roomBudget: e.stockPrice, //锁死数
              currency: e.currency,//币种
            })
          })
        }else{
          hotelRoomList = [{
            hotelRoomName: "", //房间类型
            roomNumber: "", //房间数
            roomBudget: "", //锁死数
            currency: '',//币种
          }]
        }
        return {
          adult: number&&number==1?null:this.budget.useNumber, //成人数量
          children: '',  //儿童数量
          location: '',//地段
          star: '', //酒店星级
          breakfast: '', //含早
          remarks: "",//备注
          hotelRoomList: hotelRoomList,
        };
      }else if(type=='site'){
        var obj = {
          cityId:null,
          cityName:null,
          dateType:1,
          useDate:this.dateFormatYMD(this.planDay.planDate,"-"),
          useDay:null,
          activeType:null,
          peopleType:null,
          peopleNumber:null,
          peopleNumRange:null,
          budgetPrice:null,
          currency:null,
          containServiceMap:{
            "场地":[],
            "人员":[],
            "设备":[],
            "策划":[],
            "宣传":[],
            "物料":[],
            "餐饮":[],
            "旅游":[],
          },
          remarks:null,
        }
        return obj;
      }else{
        var obj={
          adult:number&&number==1?null:this.budget.useNumber,
          children:null,
          planType:-1,
          remarks:null,
        }
        var inquiryObj = JSON.parse(JSON.stringify(this[this.nowShowTypeObj.propName]))  
        this.$set(inquiryObj,'useDate',this.dateFormatYMD(this.planDay.planDate,"-"))    
        if(type=='spot'&&data){
          this.$set(inquiryObj,'spotId',data.nameId)    
          this.$set(inquiryObj,'spotName',data.nameCn)
          this.$set(inquiryObj,'cityId',data.cityId)   
          this.$set(inquiryObj,'cityName',data.cityName)       
        }   
        this.$set(obj,this.nowShowTypeObj.propName,[inquiryObj])   
        if(type=='visa'){
          this.$set(obj,'countrys',[])  
        }    
        return obj
      }
    },
    closeDialog(){
      this.dialogVisible = false
      this.planDays.forEach(e=>{
        this.$set(e, "inquiryObj", null);  
      })
    },
    tabCheckType(item,data){
      this.nowShowType = item
      this.nowShowTypeObj = this.$refs.inquiryTypeTab.navTabData.find(e=>e.nameEn==this.nowShowType) 
      if(data&&data.day){
        this.planDay = this.planDays.find(e=>e.planDay==data.day)
      }else if(data&&data.stayDate){
        this.planDay = this.planDays.find(e=>this.dateFormatYMD(e.planDate,"-")==data.stayDate)
      }else{
        this.planDay = this.planDays[0]
      }
      if(this.planDay.inquiryObj[this.nowShowType]==undefined){
        this.$set(this.planDay.inquiryObj,this.nowShowType, this.setHotelData(this.nowShowType,null,data));
      }
    },
    copyData(){
      var preCityInfo;//当前选中天得前一天
      for(var i=this.planDays.length-1;i>=0;i--){
        var obj = this.planDays[i];
        if(obj.planDay<this.planDay.planDay){
          preCityInfo = obj.inquiryObj;
          break
        }
      }
      var cityStr ;
      if(preCityInfo[this.nowShowType]){
        cityStr = JSON.stringify(preCityInfo[this.nowShowType]);
      }else{
        cityStr = JSON.stringify(this.setHotelData(this.nowShowType));
      }
      var obj = JSON.parse(cityStr)
      if(this.nowShowType=='site'){
        this.$set(obj,'useDate',this.dateFormatYMD(this.planDay.planDate,"-")) 
      }else if(this.nowShowType!='hotel'){
        var inquiryObj = obj[this.nowShowTypeObj.propName] 
        inquiryObj.forEach(e=>{
          this.$set(e,'useDate',this.dateFormatYMD(this.planDay.planDate,"-"))
        })   
      }         
      this.$set(this.planDay.inquiryObj,this.nowShowType,obj)
    },
    tipInfo(type,item){
      var message ;
      if(type==1){
        message = '该天的需求已存在，是否需要复制前一天的数据进行替换';
      }else{
        message = '数据已清空，是否需要复制前一天的数据';
      }
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.copyData()
      }).catch(() => {
        if(type==2){
          this.emptyData(item)
        }
      })
    },
    emptyData(item){
      this.$set(item,this.nowShowType, this.setHotelData(this.nowShowType));
    },
    handleCheckedCitiesChange (item) {
      this.planDay = item;
      //首先判断是否需要复制前一天得数据,如果是第一次点击需要复制前一天的数据
      if(this.planDay.planDay!=1){
        if(this.planDay.inquiryObj[this.nowShowType]){
          this.tipInfo(1)
        }else{
          this.copyData()
        }
      }
    },
  },
  mounted(){
    this.$Bus.$on('changePlanInfo',data=>{  
      this.planDays = data.budgetMain.planDayList
      this.planDays.forEach(e=>{
        var countryList = []
        e.cityList.forEach(ee=>{
          if(countryList.findIndex(eee=>eee.countryId==ee.countryId)==-1){
            countryList.push({
              countryId:ee.countryId,
              countryName:ee.countryName
            })
          }
        })
        e.countryList = countryList
      })
      this.budget = data.budgetMain
    })
  },
  beforeDestroy(){
    this.$Bus.$off("changePlanInfo");
  },
}
</script>

<style lang="scss" scoped>
.planProductInquiry{
  .dialogMain{
    display: flex;
    margin-top: 0.3rem;
    .dialogLeftP1{
      margin-bottom: 0.2rem;
      color: #000;
      font-size: 0.2rem;
      font-weight: bold;
      text-align: center;
      >span{
        color: #605959;
        font-size: 0.14rem;
        float: right;
      }
    }
    .dialogFa{
      width: 6.2rem;
      .dialogLeft{
        color: #101010;
        padding: 0.3rem 0.2rem 0.2rem 0.2rem;
        border-radius: 5px;
        .dialogRightChoose{
          >span{
            font-size: 0.12rem;
          }
          .span2{
            color: #609ccf;
            font-weight: bold;
          }
          .dialogRightChooseMain{
            display: flex;
            justify-content: space-between;
            width: 5.3rem;
            font-size: 0.12rem;
            color: #e65019;
            >div{
              margin: 0.05rem 0 0 0.2rem;
            }
            >span{
              margin-top: 0.05rem;
              white-space: break-spaces;
            }
            >i{
              color: #609ccf;
              font-size: 0.16rem;
              font-weight: bold;
            }
          }
        }
      }
    }
    .dialogRightTitle{
      width: 6.62rem;
      .dialogRight{
        margin-left: 0.27rem;
        box-shadow: 0px 0px 13px 9px rgba(0,0,0,0.09);
        border: 1px solid rgba(0,0,0,0.09);
        border-radius: 15px;
        padding: 0.2rem;
        .dialogRightContent{
          /deep/ .people_box{
            padding: 0.15rem !important;
            background-color: #fff7e6 !important;
            font-size: 0.14rem;
          }
          .dialogRightContentButton{
            background-color: #fff7e6;
            padding: 0.15rem;
            color: #000;
            .content{
              >p{
                margin-top: 0.1rem;
                padding-left: 0.1rem;
                display: flex;
                align-items: center;
                >div{
                  margin-left: 0.1rem;
                }
                >label{
                  margin-left: 0.1rem;
                }
              }
            }
            /deep/ .el-radio{
              margin-right: 0.1rem !important;
            }
            .operationButton /deep/ i{
              color: #609ccf;
              font-size: 0.23rem;
              font-weight: bold;
            }
            /deep/ .span4{
              width: 0.21rem;
              height: 0.21rem;
              border-radius: 50%;
              margin-right: 0.06rem;
              cursor: pointer;
              display: inline-block;
              background-color: #609cc3;
              color: #fff;
              text-align: center;
              line-height: 0.21rem;
            }
            .trafficProductInquiry{
              /deep/ .typeParent{
                width: 2.3rem;
              }
              /deep/ .typeSon{
                width: 1.5rem !important;
              }
              /deep/ .busNumber{
                width: 0.48rem !important;
              }
            }
            .businessType{
              /deep/ .el-radio__label{
                padding-left: 0.05rem;
              }
              /deep/ .el-radio{
                margin-left:0 !important;
                margin-right: 0 !important;
              }
            }
          }
        }
      }
    }
  }
  /deep/ .type_tab ul{
    padding-left: 0rem !important;
  }
  /deep/ .el-radio__input.is-checked .el-radio__inner{
    background: #02a0c6 !important;
    border-color: #02a0c6 !important;
    box-shadow: 0 0 0 3px white inset !important;
  }
  /deep/ .el-radio__inner::after {
    background-color: #02a0c6;
  }
  /deep/ .el-radio__inner {
    width: 0.19rem;
    height: 0.19rem;
  }
  /deep/ .el-radio__input.is-checked+.el-radio__label {
    color: black;
  }
}
</style>